import React from 'react';
import './Message.css';

const formatMessage = (text) => {
  if (!text) return null;
  const lines = text.split('\n');
  return lines.map((line, i) => {
    const parts = line.split(/(\*\*[^*]+\*\*)/g).map((part, j) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={j}>{part.slice(2, -2)}</strong>;
      }
      return part;
    });
    return (
      <span key={i}>
        {parts}
        {i < lines.length - 1 && <br />}
      </span>
    );
  });
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:4000';

const Message = ({ message, sender, timestamp, isResume }) => {
  const isUser = sender === 'user';
  return (
    <div className={`chatbot-message ${isUser ? 'chatbot-message-user' : ''}`}>
      <div className={`chatbot-message-bubble ${isUser ? 'chatbot-message-bubble-user' : 'chatbot-message-bubble-bot'}`}>
        {formatMessage(message)}
        {isResume && (
          <a
            href={`${BACKEND_URL}/api/resume/download`}
            download="JoseAyala_Resume.pdf"
            className="resume-download-btn"
          >
            Download Resume
          </a>
        )}
        {timestamp && (
          <div className="message-timestamp">{timestamp}</div>
        )}
      </div>
    </div>
  );
};

export default Message;
